import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

const ColorMask = forwardRef((props, ref) => {
  const { onChange, ...rest } = props;

  return (
    <IMaskInput
      {...rest}
      mask="#hhhhhh"
      definitions={{
        h: /[0-9a-fA-F]/,
      }}
      inputRef={ref}
      onAccept={(value) => {
        if (onChange) onChange(value);
      }}
      overwrite
    />
  );
});

export default ColorMask;
